export default __webpack_public_path__ + "media/components/PackageEditor/images/preview-calendar_picker-a0613f87f00aa1cca49bbecfb7221a8c.png";